const AmountPicker = ({ setAmount }) => {
  return (
    <>
      <input
        type="number"
        className="form-control"
        placeholder="amount*"
        onChange={(e) => setAmount(e.target.value)}
        style={{ padding: "10px", marginBottom: "10px" }}
        required
        min="1"
      />
    </>
  );
};

export default AmountPicker;
